import {
	ConversionException,
	ConversionMigrationResult,
	ConversionMigrationStep,
	ConversionSkippedInvoice,
} from './ConversionMigrationResult';

/** Live view of a bulk step: one conversion step (1-11) run for every carrier on the conversion list. */
export class ConversionBulkStepProgress {
	runId: string;
	/** The step being run (1-11) and its name. */
	step: number;
	stepName: string;
	isComplete: boolean;
	activity: string;
	completed: number;
	total: number;
	succeeded: number;
	/** "carrier: reason" for each carrier the step was not run for (e.g. no FactorCloud client yet). */
	skipped: string[];
	/** "carrier: reason" for each carrier the step failed for. */
	failures: string[];
	exceptions: ConversionException[];
	/** Negative invoices step 9 did not post. */
	skippedNegativeInvoices: ConversionSkippedInvoice[];
	/** Started with "stop at the first failure". */
	stopOnFailure: boolean;
	/** Stopped before the end (Stop button, or the first failure). */
	stopped: boolean;
	/** Started with "include carriers already done". */
	includeCompleted: boolean;
	/** Carriers left out because an earlier run of this step already succeeded for them. */
	alreadyDone: number;
	/** Step 4 only: what importing every carrier's debtors once each did. */
	debtorSummary: string;
	/** Work done before the carriers run (step 4: the distinct debtors), for the progress bar; prepTotal 0 = none (or the carriers are running). */
	prepCompleted: number;
	prepTotal: number;
	prepLabel: string;
	/** Step 9 only: what the one CSV import of every carrier's invoices did. */
	invoiceImportSummary: string;
	/** Step 9 only: FactorCloud's failed rows of that import ({file}_errors.csv), for the download. */
	invoiceImportErrorFiles: string[];
	summary: string;
	errorMessage: string;
	startedOn: string;
	finishedOn: string;
}

export class ConversionMigrationProgress {
	runId: string;
	clientName: string;
	isComplete: boolean;
	/** Step currently running (1-11); null before the first step starts. */
	currentStep: number;
	activity: string;
	completed: number;
	total: number;
	startedOn: string;
	updatedOn: string;
	finishedOn: string;
	/** UTC start time of each step, keyed by step number. */
	stepStartedOn: { [step: string]: string };
	steps: ConversionMigrationStep[];
	/** Step number of stepNames[0]: 1 for Part 1 and the full conversion, 7 for Part 2. */
	firstStep: number;
	stepNames: string[];
	result: ConversionMigrationResult;
	errorMessage: string;
}



// WEBPACK FOOTER //
// ./src/app/portal/conversion/models/ConversionMigrationProgress.ts